'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $f_s_Product22__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.po;
      break;
    }
    case 1: {
      return $thiz.pz;
      break;
    }
    case 2: {
      return $thiz.pD;
      break;
    }
    case 3: {
      return $thiz.pE;
      break;
    }
    case 4: {
      return $thiz.pF;
      break;
    }
    case 5: {
      return $thiz.pG;
      break;
    }
    case 6: {
      return $thiz.pH;
      break;
    }
    case 7: {
      return $thiz.pI;
      break;
    }
    case 8: {
      return $thiz.pJ;
      break;
    }
    case 9: {
      return $thiz.pp;
      break;
    }
    case 10: {
      return $thiz.pq;
      break;
    }
    case 11: {
      return $thiz.pr;
      break;
    }
    case 12: {
      return $thiz.ps;
      break;
    }
    case 13: {
      return $thiz.pt;
      break;
    }
    case 14: {
      return $thiz.pu;
      break;
    }
    case 15: {
      return $thiz.pv;
      break;
    }
    case 16: {
      return $thiz.pw;
      break;
    }
    case 17: {
      return $thiz.px;
      break;
    }
    case 18: {
      return $thiz.py;
      break;
    }
    case 19: {
      return $thiz.pA;
      break;
    }
    case 20: {
      return $thiz.pB;
      break;
    }
    case 21: {
      return $thiz.pC;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 21)"));
    }
  }
}
export { $f_s_Product22__productElement__I__O as $f_s_Product22__productElement__I__O };
